import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';

@Component({
  selector: 'app-holdbacks-admin',
  templateUrl: './holdbacks-admin.component.html',
  styleUrls: ['./holdbacks-admin.component.css']
})
export class HoldbacksAdminComponent implements OnInit {
  data: any[] = [];
  status: string = '';
  userId: string = '';
  from: Date | null = null;
  to: Date | null = null;

  loading = false;

  constructor(private api: DataserviceService) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;
    const params: any = {};
    if (this.status) params.status = this.status;
    if (this.userId) params.userId = this.userId;
    if (this.from) params.from = this.from.toISOString();
    if (this.to) params.to = this.to.toISOString();
    this.api.get(`payplans/holdbacks`, { params }).subscribe({
      next: (res: any) => {
        this.data = res || [];
        this.loading = false;
      },
      error: () => { this.loading = false; }
    });
  }
}


